import _ from 'underscore';
import moment from 'moment';
import {
  converODataObjectToDeviceState, converODataObjectToABWState, converODataObjectToLengthOfStayState, converODataObjectToCheckinDayState, converODataObjectToCheckinDateState, converODataObjectToUserSetDatesState,
  getCampaignTargetsCriterions, getAdGroupTargetsCriterions,
  updateDeviceByResponse, updateABWByResponse, updateCheckinDayByResponse, updateLengthOfStayByResponse, updateCheckinDateByResponse, updateUserSetDatesByResponse,
} from '@bingads-webui-campaign/hotel-common-upsert';


/* eslint-disable no-plusplus */
function commonConvertTargetStateToTargetSchema({
  campaign, adgroup, target, CriterionType, targetCriterion,
}) {
  const { useParentLevel } = target;
  const currentLevelSettings = [...target.currentLevelSettings];
  let newCurrentLevelSettings = [];
  const targetSchema = [];
  if (useParentLevel) {
    for (let i = 0; i < currentLevelSettings.length; i++) {
      const item = { ...currentLevelSettings[i] };
      if (item.Id) {
        item.Status = 'Deleted';
        newCurrentLevelSettings.push(item);
      } else {
        currentLevelSettings.splice(i, 1);
        i--;
      }
    }
  } else {
    newCurrentLevelSettings = currentLevelSettings;
  }
  newCurrentLevelSettings.sort(a => (a.Status === 'Deleted' ? -1 : 1)); // Place the deleted item in front of the array
  const parentParams = {};
  if (adgroup.Id) {
    parentParams.AdGroup = { Id: adgroup.Id };
  } else {
    parentParams.AdGroupName = adgroup.name.value;
  }
  parentParams.CampaignName = campaign.Name;
  for (let i = 0; i < newCurrentLevelSettings.length; i++) {
    const item = newCurrentLevelSettings[i];
    if (item) {
      targetSchema.push({
        Id: item.Id,
        CriterionType,
        ...parentParams,
        Status: item.Status,
        Criterion: {
          BidAdjustment: item.bidAdjustmentDropdown === 'Increase by' ? item.bidAdjustmentInput - 0 : -(item.bidAdjustmentInput - 0),
          Type: CriterionType,
          ...targetCriterion(item),
        },
      });
    }
  }
  return { targetSchema, currentLevelSettings: newCurrentLevelSettings };
}

export const convertDeviceStateToDeviceSchema = (adgroup, campaign, initTargets) => {
  const DeviceMap = {
    Tablet: 'Tablets',
    Computer: 'Computers',
    Smartphone: 'Smartphones',
  };
  const currentDeviceSchema = commonConvertTargetStateToTargetSchema({
    campaign,
    adgroup,
    target: adgroup.device,
    CriterionType: 'Device',
    targetCriterion(item) {
      return { DeviceCriterion: { DeviceName: DeviceMap[item.device] } };
    },
  });
  let currentDeviceSchemaResult = [];
  if (!_.isEqual(initTargets, currentDeviceSchema.currentLevelSettings)) {
    currentDeviceSchemaResult = currentDeviceSchema.targetSchema;
  }
  return currentDeviceSchemaResult;
};

export const convertABWStateToABWSchema = (adgroup, campaign, initTargets) => {
  const currentABWSchema = commonConvertTargetStateToTargetSchema({
    campaign,
    adgroup,
    target: adgroup.ABW,
    CriterionType: 'AdvanceBookingWindow',
    targetCriterion(item) {
      return { AdvanceBookingWindowCriterion: { MinDays: item.minimumDays, MaxDays: item.maximumDays } };
    },
  });
  let currentABWSchemaResult = [];
  if (!_.isEqual(initTargets, currentABWSchema.currentLevelSettings)) {
    currentABWSchemaResult = currentABWSchema.targetSchema;
  }
  return currentABWSchemaResult;
};

export const convertCheckInDayStateToCheckInDaySchema = (adgroup, campaign, initTargets) => {
  const currentCheckinDaySchema = commonConvertTargetStateToTargetSchema({
    campaign,
    adgroup,
    target: adgroup.checkinDay,
    CriterionType: 'CheckInDay',
    targetCriterion(item) {
      return { CheckInDayCriterion: { CheckInDay: item.day } };
    },
  });
  let currentCheckinDaySchemaResult = [];
  if (!_.isEqual(initTargets, currentCheckinDaySchema.currentLevelSettings)) {
    currentCheckinDaySchemaResult = currentCheckinDaySchema.targetSchema;
  }
  return currentCheckinDaySchemaResult;
};

export const convertLengthofStayStateToLengthofStaySchema = (adgroup, campaign, initTargets) => {
  const currentLengthOfStaySchema = commonConvertTargetStateToTargetSchema({
    campaign,
    adgroup,
    target: adgroup.lengthOfStay,
    CriterionType: 'LengthofStay',
    targetCriterion(item) {
      return { LengthofStayCriterion: { MinNights: item.minimumNumber, MaxNights: item.maximumNumber } };
    },
  });
  let currentLengthofStaySchemaResult = [];
  if (!_.isEqual(initTargets, currentLengthOfStaySchema.currentLevelSettings)) {
    currentLengthofStaySchemaResult = currentLengthOfStaySchema.targetSchema;
  }
  return currentLengthofStaySchemaResult;
};

export const convertCheckInDateStateToCheckInDateSchema = (adgroup, campaign, initTargets) => {
  const currentCheckinDateSchema = commonConvertTargetStateToTargetSchema({
    campaign,
    adgroup,
    target: adgroup.checkinDate,
    CriterionType: 'CheckInDate',
    targetCriterion(item) {
      return { CheckInDateCriterion: { StartDate: moment(item.startDate).format('yyyy-MM-DD'), EndDate: moment(item.endDate).format('yyyy-MM-DD') } };
    },
  });
  let currentCheckinDateSchemaResult = [];
  if (!_.isEqual(initTargets, currentCheckinDateSchema.currentLevelSettings)) {
    currentCheckinDateSchemaResult = currentCheckinDateSchema.targetSchema;
  }
  return currentCheckinDateSchemaResult;
};

export const convertUserSetDatesStateToUserSetDatesSchema = (adgroup, campaign, initTargets) => {
  const UserSetDatesMap = {
    'Selected date': 'UserSelection',
    'Default date': 'DefaultSelection',
  };

  const currentUserSetDatesSchema = commonConvertTargetStateToTargetSchema({
    campaign,
    adgroup,
    target: adgroup.userSetDates,
    CriterionType: 'DateSelectionType',
    targetCriterion(item) {
      return { DateSelectionTypeCriterion: { HotelDateSelectionType: UserSetDatesMap[item.dates] } };
    },
  });
  let currentUserSetDatesSchemaResult = [];
  if (!_.isEqual(initTargets, currentUserSetDatesSchema.currentLevelSettings)) {
    currentUserSetDatesSchemaResult = currentUserSetDatesSchema.targetSchema;
  }
  return currentUserSetDatesSchemaResult;
};


export const renderAdGroupTargets = (cid, aid, campaignId, adGroupId, patchAdgroup, adgroup, context) => {
  const getCampaignDeviceCriterionsPromise = getCampaignTargetsCriterions({
    type: "isof(Criterion,'Model.DeviceCriterion')", cid, aid, campaignId,
  });

  if (adGroupId) {
    const adgroupTargetsPromises = [];
    const getAdGroupDeviceCriterionsPromise = getAdGroupTargetsCriterions({
      type: "isof(Criterion,'Model.DeviceCriterion')", cid, aid, campaignId, adGroupId,
    });
    adgroupTargetsPromises.push(Promise.all([getCampaignDeviceCriterionsPromise, getAdGroupDeviceCriterionsPromise]).then(([campaignTargets, adGroupTargets]) => {
      const deviceCriterion = converODataObjectToDeviceState(adGroupTargets);
      context.setState(prev => ({ initTargets: { ...prev.initTargets, device: adGroupTargets.length > 0 ? deviceCriterion : [] } }));
      patchAdgroup('device', {
        parentLevelSettings: converODataObjectToDeviceState(campaignTargets),
        currentLevelSettings: deviceCriterion,
        useParentLevel: adGroupTargets.length === 0,
        reset: true,
      });
    }));


    const getAdGroupABWCriterionsPromise = getAdGroupTargetsCriterions({
      type: "isof(Criterion,'Model.AdvanceBookingWindowCriterion')", cid, aid, campaignId, adGroupId,
    });
    adgroupTargetsPromises.push(Promise.all([getAdGroupABWCriterionsPromise]).then(([adGroupTargets]) => {
      const ABWCriterion = converODataObjectToABWState(adGroupTargets);
      context.setState(prev => ({ initTargets: { ...prev.initTargets, ABW: adGroupTargets.length > 0 ? ABWCriterion : [] } }));
      if (adGroupTargets.length > 0) {
        patchAdgroup('ABW', {
          ...adgroup.ABW,
          currentLevelSettings: ABWCriterion,
          useParentLevel: adGroupTargets.length === 0,
          reset: true,
        });
      }
    }));


    const getAdGroupLengthOfStayCriterionsPromise = getAdGroupTargetsCriterions({
      type: "isof(Criterion,'Model.LengthOfStayCriterion')", cid, aid, campaignId, adGroupId,
    });
    adgroupTargetsPromises.push(Promise.all([getAdGroupLengthOfStayCriterionsPromise]).then(([adGroupTargets]) => {
      const lengthOfStayCriterion = converODataObjectToLengthOfStayState(adGroupTargets);
      context.setState(prev => ({ initTargets: { ...prev.initTargets, lengthOfStay: adGroupTargets.length > 0 ? lengthOfStayCriterion : [] } }));
      if (adGroupTargets.length > 0) {
        patchAdgroup('lengthOfStay', {
          ...adgroup.lengthOfStay,
          currentLevelSettings: lengthOfStayCriterion,
          useParentLevel: adGroupTargets.length === 0,
          reset: true,
        });
      }
    }));


    const getAdGroupCheckinDayCriterionsPromise = getAdGroupTargetsCriterions({
      type: "isof(Criterion,'Model.CheckInDayCriterion')", cid, aid, campaignId, adGroupId,
    });
    adgroupTargetsPromises.push(Promise.all([getAdGroupCheckinDayCriterionsPromise]).then(([adGroupTargets]) => {
      const checkinDayCriterion = converODataObjectToCheckinDayState(adGroupTargets);
      context.setState(prev => ({ initTargets: { ...prev.initTargets, checkinDay: adGroupTargets.length > 0 ? checkinDayCriterion : [] } }));
      if (adGroupTargets.length > 0) {
        patchAdgroup('checkinDay', {
          ...adgroup.checkinDay,
          currentLevelSettings: checkinDayCriterion,
          useParentLevel: adGroupTargets.length === 0,
          reset: true,
        });
      }
    }));


    const getAdGroupCheckinDateCriterionsPromise = getAdGroupTargetsCriterions({
      type: "isof(Criterion,'Model.CheckInDateCriterion')", cid, aid, campaignId, adGroupId,
    });
    adgroupTargetsPromises.push(Promise.all([getAdGroupCheckinDateCriterionsPromise]).then(([adGroupTargets]) => {
      const checkinDateCriterion = converODataObjectToCheckinDateState(adGroupTargets);
      context.setState(prev => ({ initTargets: { ...prev.initTargets, checkinDate: adGroupTargets.length > 0 ? checkinDateCriterion : [] } }));
      if (adGroupTargets.length > 0) {
        patchAdgroup('checkinDate', {
          ...adgroup.checkinDate,
          currentLevelSettings: checkinDateCriterion,
          useParentLevel: adGroupTargets.length === 0,
          reset: true,
        });
      }
    }));


    const getAdGroupUserSetDatesCriterionsPromise = getAdGroupTargetsCriterions({
      type: "isof(Criterion,'Model.DateSelectionTypeCriterion')", cid, aid, campaignId, adGroupId,
    });
    adgroupTargetsPromises.push(Promise.all([getAdGroupUserSetDatesCriterionsPromise]).then(([adGroupTargets]) => {
      const userSetDatesCriterion = converODataObjectToUserSetDatesState(adGroupTargets);
      context.setState(prev => ({ initTargets: { ...prev.initTargets, userSetDates: adGroupTargets.length > 0 ? userSetDatesCriterion : [] } }));
      patchAdgroup('userSetDates', {
        ...adgroup.userSetDates,
        currentLevelSettings: userSetDatesCriterion,
        useParentLevel: adGroupTargets.length === 0,
        reset: true,
      });
    }));
    return Promise.all(adgroupTargetsPromises);
  }
  return Promise.all([getCampaignDeviceCriterionsPromise]).then(([campaignTargets]) => {
    context.setState(prev => ({ initTargets: { ...prev.initTargets, device: [] } }));
    patchAdgroup('device', {
      ...adgroup.device,
      parentLevelSettings: converODataObjectToDeviceState(campaignTargets),
      reset: true,
    });
  });
};


export const updateAllTargets = (resources, context) => {
  const DeviceCriterion = [];
  const ServerDeviceCriterion = [];
  const ABWCriterion = [];
  const ServerABWCriterion = [];
  const CheckinDayCriterion = [];
  const ServerCheckinDayCriterion = [];
  const LengthOfStayCriterion = [];
  const ServerLengthOfStayCriterion = [];
  const CheckinDateCriterion = [];
  const ServerCheckinDateCriterion = [];
  const UserSetDatesCriterion = [];
  const ServerUserSetDatesCriterion = [];
  _.each(resources, (criterion) => {
    switch (criterion.CriterionType) {
      case 'Device':
      case 'OriginalDevice':
        DeviceCriterion.push(criterion);
        if (!criterion.errors) {
          ServerDeviceCriterion.push(criterion);
        }
        break;
      case 'AdvanceBookingWindow':
        ABWCriterion.push(criterion);
        if (!criterion.errors) {
          ServerABWCriterion.push(criterion);
        }
        break;
      case 'CheckInDay':
        CheckinDayCriterion.push(criterion);
        if (!criterion.errors) {
          ServerCheckinDayCriterion.push(criterion);
        }
        break;
      case 'LengthofStay':
        LengthOfStayCriterion.push(criterion);
        if (!criterion.errors) {
          ServerLengthOfStayCriterion.push(criterion);
        }
        break;
      case 'CheckInDate':
        CheckinDateCriterion.push(criterion);
        if (!criterion.errors) {
          ServerCheckinDateCriterion.push(criterion);
        }
        break;
      case 'DateSelectionType':
        UserSetDatesCriterion.push(criterion);
        if (!criterion.errors) {
          ServerUserSetDatesCriterion.push(criterion);
        }
        break;
      default:
        break;
    }
  });
  const currentCriterionMap = {};
  if (DeviceCriterion.length > 0) {
    updateDeviceByResponse(DeviceCriterion, context.state.adgroup.device, context.patchAdgroup);
  }
  if (ServerDeviceCriterion.length > 0) {
    const currentDeviceCriterion = updateDeviceByResponse(ServerDeviceCriterion, context.state.adgroup.device);
    currentCriterionMap.device = currentDeviceCriterion;
  }
  if (ABWCriterion.length > 0) {
    updateABWByResponse(ABWCriterion, context.state.adgroup.ABW, context.patchAdgroup);
  }
  if (ServerABWCriterion.length > 0) {
    const currentABWCriterion = updateABWByResponse(ServerABWCriterion, context.state.adgroup.ABW);
    currentCriterionMap.ABW = currentABWCriterion;
  }
  if (CheckinDayCriterion.length > 0) {
    updateCheckinDayByResponse(CheckinDayCriterion, context.state.adgroup.checkinDay, context.patchAdgroup);
  }
  if (ServerCheckinDayCriterion.length > 0) {
    const currentCheckinDayCriterion = updateCheckinDayByResponse(ServerCheckinDayCriterion, context.state.adgroup.checkinDay);
    currentCriterionMap.checkinDay = currentCheckinDayCriterion;
  }
  if (LengthOfStayCriterion.length > 0) {
    updateLengthOfStayByResponse(LengthOfStayCriterion, context.state.adgroup.lengthOfStay, context.patchAdgroup);
  }
  if (ServerLengthOfStayCriterion.length > 0) {
    const currentLengthOfStayCriterion = updateLengthOfStayByResponse(ServerLengthOfStayCriterion, context.state.adgroup.lengthOfStay);
    currentCriterionMap.lengthOfStay = currentLengthOfStayCriterion;
  }
  if (CheckinDateCriterion.length > 0) {
    updateCheckinDateByResponse(CheckinDateCriterion, context.state.adgroup.checkinDate, context.patchAdgroup);
  }
  if (ServerCheckinDateCriterion.length > 0) {
    const currentCheckinDateCriterion = updateCheckinDateByResponse(ServerCheckinDateCriterion, context.state.adgroup.checkinDate);
    currentCriterionMap.checkinDate = currentCheckinDateCriterion;
  }
  if (UserSetDatesCriterion.length > 0) {
    updateUserSetDatesByResponse(UserSetDatesCriterion, context.state.adgroup.userSetDates, context.patchAdgroup);
  }
  if (ServerUserSetDatesCriterion.length > 0) {
    const currentUserSetDatesCriterion = updateUserSetDatesByResponse(ServerUserSetDatesCriterion, context.state.adgroup.userSetDates);
    currentCriterionMap.userSetDates = currentUserSetDatesCriterion;
  }
  context.setState(prev => ({
    initTargets: {
      ...prev.initTargets,
      ...currentCriterionMap,
    },
  }));
};
